// extracted by mini-css-extract-plugin
export default {"SiteLightGrey":"#B1B1B1","SiteDarkGrey":"#5A6268","Button":"SecondaryButton_Button__iLCui"};